const ratingColors = {
    1: 'bg-green-100 text-green-800',
    2: 'bg-green-100 text-green-700',
    3: 'bg-yellow-100 text-yellow-800',
    4: 'bg-orange-100 text-orange-800',
    5: 'bg-red-100 text-red-700',
    6: 'bg-red-100 text-red-800',
};

const parameters = [
    { key: 'incomeScore', label: 'Monthly Income', weight: '25%' },
    { key: 'dtiScore', label: 'DTI Band', weight: '25%' },
    { key: 'bureauScore', label: 'Credit Bureau', weight: '20%' },
    { key: 'tenureScore', label: 'Employer Tenure', weight: '15%' },
    { key: 'standingOrderScore', label: 'Standing Order', weight: '15%' },
];

function RiskScoreSection({ riskScore }) {
    if (!riskScore || !riskScore.totalScore) {
        return (
            <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-y border-gray-200 rounded-t-lg">
                    <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Risk Score</h3>
                </div>
                <div className="px-4 py-6 text-center text-sm text-gray-400">
                    Click "Compute DTI & Score" to generate the risk score.
                </div>
            </div>
        );
    }

    const ratingColor = ratingColors[riskScore.riskRating] || 'bg-gray-100 text-gray-700';

    return (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-y border-gray-200 rounded-t-lg">
                <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Risk Score</h3>
                <span className={`inline-block px-2.5 py-1 text-xs font-semibold rounded-full ${ratingColor}`}>
                    Rating {riskScore.riskRating} — {riskScore.riskLabel}
                </span>
            </div>

            {/* Score Table */}
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-gray-50/50">
                            <th className="text-left px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase">Parameter</th>
                            <th className="text-center px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase">Score</th>
                            <th className="text-center px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase">Weight</th>
                            <th className="text-center px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase">Weighted</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {parameters.map(p => {
                            const score = riskScore[p.key] || 0;
                            const weightNum = parseFloat(p.weight) / 100;
                            const weighted = Math.round(score * weightNum);
                            return (
                                <tr key={p.key} className="hover:bg-gray-50/40">
                                    <td className="px-4 py-2.5 text-gray-700">{p.label}</td>
                                    <td className="px-4 py-2.5 text-center font-medium text-gray-900">{score}</td>
                                    <td className="px-4 py-2.5 text-center text-gray-500">{p.weight}</td>
                                    <td className="px-4 py-2.5 text-center font-medium text-gray-900">{weighted}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr className="bg-blue-50/50 border-t-2 border-gray-200">
                            <td className="px-4 py-3 font-semibold text-gray-700">Total</td>
                            <td className="px-4 py-3 text-center font-bold text-[#1e3a6e]">{riskScore.totalScore}</td>
                            <td className="px-4 py-3 text-center text-gray-500">100%</td>
                            <td className="px-4 py-3 text-center font-bold text-[#1e3a6e]">{riskScore.totalScore}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* Summary */}
            <div className="divide-y divide-gray-100 border-t border-gray-200">
                <div className="flex items-center justify-between px-4 py-2.5">
                    <span className="text-sm text-gray-600">Risk Rating</span>
                    <span className={`inline-block px-2.5 py-1 text-xs font-semibold rounded-full ${ratingColor}`}>
                        {riskScore.riskRating} — {riskScore.riskLabel}
                    </span>
                </div>
                <div className="flex items-center justify-between px-4 py-2.5">
                    <span className="text-sm text-gray-600">Risk Premium</span>
                    <span className="text-sm font-medium text-gray-900">+{riskScore.riskPremium}%</span>
                </div>
            </div>
        </div>
    );
}

export default RiskScoreSection;
